import script from "./SeatConfirmationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SeatConfirmationDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__